import { MDSZIndexes } from "@/mds/foundations";
import { ModalOverlayProps } from "react-aria-components";

export const MDSModalZIndex = {
  Default: MDSZIndexes.StandardModal,
  AppStoreCrashNotice: MDSZIndexes.AppStoreCrashNotice,
} as const;

export type MDSModalZIndex = (typeof MDSModalZIndex)[keyof typeof MDSModalZIndex];

export interface IMDSModalProps extends ModalOverlayProps {
  isOpen?: boolean;
  handleClose?: () => void;
  zIndex?: MDSModalZIndex;
}
